class MoreTag {

  constructor(){
    this.trigger = document.querySelector('[data-trigger="more-tag"]');
    this.target = document.querySelector('[data-target="more-tag"]');
    this._init();
  }

  _init(){

    if( this.trigger ){
      this.trigger.addEventListener('click', 
			(event) => this.toggleText(event)
		);
    }
  }

  toggleText(){
    console.log('click');
    this.target.setAttribute('data-state', 'visible');
    this.trigger.setAttribute('data-state', 'open');
  }  
}

export const moreTag = new MoreTag();